<template>
	<div>
		<h1>{{id}}</h1>
		<div class="about">
        	<p>{{ aktivitetInfo }}</p>
        </div>
	</div>
</template>


<script>
export default {
	data() {
		return {
			id: this.$route.params.id,
			aktiviteter: [
				{title: 'Mandag', text: 'Mandager kan barna ha med seg leker som de viser frem til de andre barna i barnehagen. De får da vise frem lekene sine i samlingsstund, grunnen til dette er at  de skal øve seg på å snakke høyt i en gruppen med flere tilhørere.  De får også øvd seg på å gi og ta imot ros.', bilde: "gutt.jpg",},
				{title: 'Tirsdag', text: 'hei2', bilde: 'trafikklys.jpg'},
				{title: 'Onsdag', text: 'hei2', bilde: 'trilleLov.jpg'},
				{title: 'Torsdag', text: 'hei2', bilde: 'sandkasse.jpg'},
				{title: 'Fredag', text: 'Fredager er det ordensbarnet som bestemmer hva vi skal gjøre i samlingen. Barnet bestemmer hva vi skal gjøre og når vi skal gjøre de ulike tingene (med hjelp fra en voksen) Fredager har vi også en fredagsboks som barna ikke vet hva vi har oppi. Barna rister da på boksen for å finne ut hva som befinner seg i boksen, før de gjetter på hva den inneholder.', bilde: 'gutt.jpg'},
				{title: 'Andre aktiviteter', text: 'hei2', bilde: 'ski.jpg'},
        	]
		}
	},
	computed: {
        aktivitetInfo() {
			let title = this.aktiviteter.filter( aktiviteter => aktiviteter.title.toLowerCase().startsWith(this.id.toLowerCase()))
            return title[0].text
        }
    },
}
</script>

<style scoped>
.about {
  margin-left: 10%;
  margin-right: 10%;
  text-align: left;
}
</style>
